import Column from '@components/column'
import AppointmentScheduleFilter from '@commons/scheduleFilter'
import AppointmentRequestCard from '@commons/cards/appointmentRequest'
import { StyleGridItems } from './style'
import Typography from '@components/typography'
import Row from '@components/row'
import Circle from '@components/circle'
import Empty from '@commons/empty'
import { Fragment, useEffect, useState } from 'react'
import { format } from 'date-fns'
import { Appointment } from '@apis'
import { useSelector } from 'react-redux'
import AppointmentRequestCardLoader from '@commons/cards/appointmentRequest/loader'
import { Actions, store } from '@store'
import Alert from '@commons/popups/alert'
import AppointmentCancel from '@commons/popups/cancel'
import useAppointmentActions from '@hooks/useAppointmentActions'
import AppointmentReschedule from '@commons/popups/reschedule'

const Schedules = () => {
  const {
    items: appointments,
    totalItems,
    loading,
  } = useSelector((state: any) => state.consultAppointments)
  const filter = useSelector((state: any) => state.consultAppointmentsFilter)
  const {
    alertInfo,
    visible,
    loading: alertLoading,
    handleClickBtn,
    handleClickYes,
    handleClose,
  } = useAppointmentActions({
    selector: 'consultAppointments',
  })
  const [params, setParams] = useState({
    page: 1,
    limit: 10,
    type: 'Consult',
    isSchedule: true,
    date: format(new Date(filter?.date), 'yyyy-MM-dd'),
  })

  const fetchData = async (params, action = 'set') => {
    await Appointment.list({
      params,
      action: action,
      state: 'consultAppointments',
    }).catch(() => {})
  }

  useEffect(() => {
    if (!appointments?.length) {
      fetchData(params)
    }
  }, [])
  return (
    <Column rowGap={20}>
      <AppointmentScheduleFilter
        date={filter?.date}
        onChange={async (date) => {
          const updateParams: any = {
            ...params,
            date: format(new Date(date), 'yyyy-MM-dd'),
          }

          if (date !== params?.date) {
            await fetchData(updateParams)
          }
          store.dispatch(
            Actions.set('consultAppointmentsFilter', {
              date: new Date(date),
            }),
          )
          setParams(updateParams)
        }}
      />
      <Row alignItems="center" colGap={10}>
        <Typography
          content={format(new Date(params?.date), "EEEE do',' MMMM yyyy")}
          tc="primary"
        />
        <Circle size={20} bg={'secondary'}>
          <Typography size={12} tc="white" content={totalItems} />
        </Circle>
      </Row>

      {!!loading ? (
        <StyleGridItems>
          {Array(6)
            .fill(0)
            ?.map((_, index: number) => {
              return (
                <Fragment key={index}>
                  <AppointmentRequestCardLoader />
                </Fragment>
              )
            })}
        </StyleGridItems>
      ) : (
        <>
          {!!appointments?.length ? (
            <StyleGridItems onClick={handleClickBtn}>
              {appointments?.map((appointment: any) => {
                return (
                  <Fragment key={appointment?.id}>
                    <AppointmentRequestCard appointment={appointment} />
                  </Fragment>
                )
              })}
            </StyleGridItems>
          ) : (
            <Empty />
          )}
        </>
      )}
      {!!visible && alertInfo?.type == 'confirm' && (
        <Alert
          title={'Confirmed Request'}
          visible={visible}
          description="Are you sure you want to confirmed request ?"
          onClickOk={handleClickYes}
          onClickClose={handleClose}
          loading={alertLoading}
        />
      )}
      {!!visible && alertInfo?.type == 'cancel' && (
        <AppointmentCancel
          onClose={handleClose}
          visible={visible}
          id={alertInfo?.id}
        />
      )}
      {!!visible && alertInfo?.type == 'reschedule' && (
        <AppointmentReschedule
          visible={visible}
          id={alertInfo?.id}
          onClose={handleClose}
          appointment={appointments?.find(
            (appointment: any) => appointment?.id == alertInfo?.id,
          )}
          selector={'consultAppointmentsFilter'}
        />
      )}
      {!!visible && alertInfo?.type == 'complete' && (
        <Alert
          title={'Completed Request'}
          visible={visible}
          description="Are you sure you want to completed appointment ?"
          onClickOk={handleClickYes}
          onClickClose={handleClose}
          loading={alertLoading}
        />
      )}
    </Column>
  )
}

export default Schedules
